import React, {memo} from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import AssaysListItem, {AssaysListItemProps} from './AssaysListItem';

export type AssaysListProps = AssaysListItemProps[];

const useStyles = makeStyles({
  root: {
    padding: 10,
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    alignContent: 'flex-start',
    overflow: 'auto',
    '& > *': {
      margin: 6,
    }
  }
});

const AssaysList = memo(({assays}: { assays: AssaysListProps }) => {
  const cl = useStyles();
  return (
    <div className={cl.root}>
      {assays.map((assay, index) => (
        <AssaysListItem key={index} {...assay}/>
      ))}
    </div>
  );
});

export default AssaysList;

